module.exports = __webpack_public_path__ + "img/20190927145240671.12330b14.jpg";